import styled from "styled-components"

export const MainInner = styled.div`
	overflow-y: scroll;
	height: 100%;
	overflow-x: hidden;
`
export const MainBannerWrapper = styled.div`
	margin-bottom: calc(100vw * (16 / 375));
`

export const MotishopBannerWrapper = styled.div`
	margin-bottom: calc(100vw * (32 / 375));
	padding: 0 calc(100vw * (17 / 375));
`

export const BranddakBannerWrapper = styled.div`
	margin-bottom: calc(100vw * (20 / 375));
	padding: 0 calc(100vw * (17 / 375));
`
